<template>
  <o-sales-view
    nav-bar-title="Blue-bike"
    title="Blue-bike Voucher 24u"
    image="images/bluebike-header.jpg"
    :points="3"
    price="3,75"
    :message="message"
    next-link="/sales/kbc/ticket/confirmation"
  />
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
export default {
  name: 'Bluebike',
  components: {
    OSalesView
  },
  data () {
    return {
      message: 'Een Blue-bike leen je voor maximum 24 uur. Fiets langer bijhouden leidt tot extra kosten, meer info vind je <a href="http://www.blue-bike.be/" target="_blank">hier</a>.'
    }
  }
}
</script>
